// NestedFormRender.js
import React, { useEffect } from "react";
import { Form, Space, Button } from "antd";
import FormItemComponent from "./FormItemComponent";
import FormItemsComponent from "./FormItemsComponent";
import utils from "utils";

const NestedFormRender = ({
  initialValues,
  fieldOptions,
  fieldValue,
  onSave,
  handleCancel,
  formClass
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [form]);

  const handleSubmit = (values) => {
    onSave(values);
  };

  return (
    <Form form={form} onFinish={handleSubmit} layout="vertical">
      <FormItemsComponent
        obj={initialValues}
        // parentName={["label"]}
        fieldOptions={fieldOptions}
        fieldValue={fieldValue}
        form={form}
        formClass={formClass}
      />
      <div>
        <Space>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              // className="cancelButton"
              style={{
                backgroundColor: "white",
                color: "var(--background-color)",
              }}
              onClick={() => handleCancel()}
            >
              Cancel
            </Button>
          </Form.Item>
        </Space>
      </div>
    </Form>
  );
};

export default NestedFormRender;
